<template>
    <toolbox-pane class="learning-path-toolbox" :collapsible="false" :class="`active-tab-${current_tab_id}`">
        <tabs :tabs="tabs" class="tabs" @change="current_tab_id = $event">

            <template #pre-tab-content v-if="current_tab.sections">
                <page-scroller-tabs class="text-center" :tabs="current_tab.sections" @change="scroll($event)" />
            </template>

            <template v-slot:[`tab-content-${tab_id}`] v-for="tab_id in tab_ids">
                <div class="px-3 pb-3" @change.stop.prevent.self="">

                    <div class="alert alert-warning small text-center">
                        <em>Add the activity or resource by dragging it to the section you want.</em>
                    </div>

                    <template v-for="(section, section_id) in tabs[tab_id].sections">
                        <div class="section-head mb-3">
                            <h6 :ref="`${tab_id}-section-${section_id}`" class="mr-1 mb-0">{{ section.name }}</h6>
                            <button v-if="section_id !== 'podcasts'" class="btn btn-light ml-auto" @click="openCanvasElementEditor(section_id)">+
                                Create</button>
                            <!--                            <create-dynamic-canvas-element-tool-->
                            <!--                                class="ml-auto"-->
                            <!--                                :type="{-->
                            <!--                                    activities: 'activity',-->
                            <!--                                    resources: 'resource',-->
                            <!--                                }[section_id]"-->
                            <!--                                @created="toolCreated()"-->
                            <!--                            />-->
                        </div>

                        <template v-if="section.filters">
                            <div v-for="(filter, filter_id) in section.filters" class="mb-3">
                                <select v-model="section.filters[filter_id]" class="form-control">
                                    <option value="">All {{ section.name }}</option>
                                    <option v-for="uniqueAction in uniqueActionGrouped(section.actions, filter_id)"
                                        :key="uniqueAction.id" :value="uniqueAction.id">{{ uniqueAction.name }}</option>
                                </select>
                            </div>
                        </template>

                        <template v-if="busy[section_id]">
                            <div class="text-center mb-3">
                                <icon-spinner :spin="true" size="16" color="dark" />
                            </div>
                        </template>
                        <template v-else>
                            <div v-if="section_id !== 'podcasts'">
                                <cloneable-tools group="activity-section" class="mb-3"
                                    :tools="filteredActions(section.actions, section.filters)">
                                    <template v-slot:tool-actions="tool">
                                        <div v-if="tool.element.user_id === current_user_id" class="custom"
                                            :title="`My ${utils.ucwords(tool.element.type)}`"></div>
                                        <div class="path-tool-actions">
                                            <a v-if="tool.element.user_id === current_user_id" href="#" class="tool-remove"
                                                @click.prevent.stop="removeTool(tool)">&times;</a>
                                        </div>
                                    </template>
                                    <template v-slot:preview-actions="preview">
                                        <div class="d-flex mr-auto">
                                            <select class="form-control w-auto mr-1" v-model="add_to_section">
                                                <option :value="null">--- Select a section to add this ---</option>
                                                <option v-for="g in lp_activity_section_groups" :disabled="!g?.group?.id"
                                                    :value="{ stage_id: g.stage_id, group_id: g.group?.id ? g.group?.id : null }">
                                                    {{ g.stage?.name }}
                                                    {{ g.group?.name ? `— ${utils.ellipsis(g.group.name)}` : ' (Add an activity group first) '}}
                                                </option>
                                            </select>
                                            <button type="button" class="btn btn-success mr-1"
                                                @click="addToSection(preview)">Add to Section</button>
                                            <button v-if="preview?.item?.item?.user_id === current_user_id" type="button"
                                                class="btn btn-primary mr-1"
                                                @click="openCanvasElementEditor(preview?.item?.item?.type, preview?.item?.item)">Edit</button>
                                        </div>
                                    </template>
                                </cloneable-tools>
                            </div>
                            <div v-else>
                                <draggable :group="{ name: 'activity-section', pull: 'clone', put: false }" :sort="false"
                                    item-key="id" :clone="cloneTool" class="tools" v-model="section.actions">
                                    <template #item="{ element }">
                                        <div class="tool">
                                            <button class="btn btn-block btn-icon btn-light" :title="element.data.file.name"
                                                @click="preview(element)">
                                                <img :src="this.uploads.image(element.data.file.preview_url)" alt="">
                                                <span class="label">{{ element.data.file.name }}</span>
                                            </button>
                                        </div>
                                    </template>
                                </draggable>
                            </div>
                        </template>

                        <!--hr v-if="section_id !== Object.keys( tabs[ tab_id ].sections ).pop()"-->

                    </template>
                </div>
            </template>
        </tabs>
        <modal :id="utils.randomId({ prefix: 'modal' })" :show="true" size="xl" v-if="this.selectedPodcast"
            @click.prevent.stop="" @close="close()">
            <template #title>{{ selectedPodcast.name }}</template>
            <PodcastPlayer :podcast="this.selectedPodcast" :hideSidebar="true" />
            <template #footer>
                <div class="d-flex mr-auto">
                    <select class="form-control w-auto mr-1" v-model="add_to_section">
                        <option :value="null">--- Select a section to add this ---</option>
                        <option v-for="g in lp_activity_section_groups" :disabled="!g?.group?.id"
                            :value="{ stage_id: g.stage_id, group_id: g.group?.id ? g.group?.id : null }">
                            {{ g.stage?.name }}
                            {{ g.group?.name ? `— ${utils.ellipsis(g.group.name)}` : ' (Add an activity group first) ' }}
                        </option>
                    </select>
                    <button type="button" class="btn btn-success mr-1" @click="addToSection2()">Add to Section</button>
                </div>
            </template>
        </modal>

        <canvas-element-editor-modal v-if="elementEditorModal.show" :type="elementEditorModal.type"
            :element="elementEditorModal.element" @close="closeCanvasElementEditor" @saved="onCanvasElementEditorSave" />

    </toolbox-pane>
</template>

<script>
import draggable from 'vuedraggable';
import uploads from "@/mixins/uploads";
import ToolboxPane from "@/Components/ToolboxPane";
import Tabs from "@/Components/Tabs";
import PageScrollerTabs from "@/Components/PageScrollerTabs";
import CloneableTools from "@/Components/Toolbox/LearningPath/CloneableTools";

// import {custom, built_in} from "@/DATA/learning_paths";
// import resources from "@/DATA/resources";
// import activities from "@/DATA/activities";
import API from "@/API";
import IconSpinner from "@/Icons/IconSpinner";
import utils from "@/mixins/utils";
import CanvasElementEditorModal from "@/Components/Toolbox/LearningPath/CanvasElementEditorModal";
import Modal from "@/Components/Common/Modal";
import PodcastPlayer from "@/Components/Podcast2/PodcastPlayer";
import {mapActions} from "vuex";


export default {
    name: "LearningPathToolbox",
    components: {
        CanvasElementEditorModal,
        CloneableTools,
        draggable,
        IconSpinner,
        PageScrollerTabs,
        Tabs,
        ToolboxPane,
        Modal,
        PodcastPlayer,
    },
    mixins: [utils, uploads],

    props: ['learningPath'],
    emits: ['reload-page'],

    data() {
        return {

            selectedPodcast: null,

            busy: {
                resources: true,
                activities: true,
                podcasts: true,
            },


            elementEditorModal: {
                show: false,
                type: null,
                element: null,
            },

            add_to_section: null,

            tabs: {
                /*path: {
                    name: 'Path',
                    sections: {
                        custom: 'Custom Paths',
                        built_in: 'DFC Recommended',
                    }
                },*/
                intro: {
                    name: 'Intro',
                    sections: {
                        activities: {
                            name: 'Activities',
                            filters: { 'activity-group': '' },
                            actions: [],
                        },
                        resources: {
                            name: 'Resources',
                            actions: []
                        },
                        podcasts: {
                            name: 'Podcasts',
                            actions: []
                        }
                    }
                },
                feel: {
                    name: 'Feel',
                    sections: {
                        // plan: {
                        //     name: 'Lesson Plans',
                        //     actions: [
                        //         { name: 'Lesson Plan Name' },
                        //         { name: 'Another Lesson Plan' },
                        //     ]
                        // },
                        activities: {
                            name: 'Activities',
                            filters: {
                                'activity-group': '',
                            },
                            actions: [
                                // activities[0],
                                // activities[1],
                            ],
                        },
                        resources: {
                            name: 'Resources',
                            actions: [
                                // resources[0],
                                // resources[1],
                                // resources[2],
                            ]
                        },
                        podcasts: {
                            name: 'Podcasts',
                            actions: []
                        }
                    }
                },
                imagine: {
                    name: 'Imagine',
                    sections: {
                        // plan: {
                        //     name: 'Lesson Plans',
                        //     actions: [
                        //         { name: 'Lesson Plan Name' },
                        //         { name: 'Another Lesson Plan' },
                        //     ]
                        // },
                        activities: {
                            name: 'Activities',
                            filters: {
                                'activity-group': '',
                            },
                            actions: [
                                // activities[2],
                                // activities[3],
                                // activities[4],
                                // activities[5],
                            ],
                        },
                        resources: {
                            name: 'Resources',
                            actions: [
                                // resources[0],
                                // resources[1],
                                // resources[2],
                            ]
                        },
                        podcasts: {
                            name: 'Podcasts',
                            actions: []
                        }
                    }
                },
                do: {
                    name: 'Do',
                    sections: {
                        // plan: {
                        //     name: 'Lesson Plans',
                        //     actions: [
                        //         { name: 'Lesson Plan Name' },
                        //         { name: 'Another Lesson Plan' },
                        //     ]
                        // },
                        activities: {
                            name: 'Activities',
                            filters: {
                                'activity-group': '',
                            },
                            actions: [
                                // activities[6],
                                // activities[7],
                                // activities[8],
                                // activities[9],
                            ],
                        },
                        resources: {
                            name: 'Resources',
                            actions: [
                                // resources[0],
                                // resources[1],
                                // resources[2],

                            ]
                        },
                        podcasts: {
                            name: 'Podcasts',
                            actions: []
                        }
                    }
                },
                share: {
                    name: 'Share',
                    sections: {
                        // plan: {
                        //     name: 'Lesson Plans',
                        //     actions: [
                        //         { name: 'Lesson Plan Name' },
                        //         { name: 'Another Lesson Plan' },
                        //     ]
                        // },
                        activities: {
                            name: 'Activities',
                            filters: {
                                'activity-group': '',
                            },
                            actions: [
                                // activities[10],
                            ],
                        },
                        resources: {
                            name: 'Resources',
                            actions: [
                                // resources[0],
                                // resources[1],
                                // resources[2],

                            ]
                        },
                        podcasts: {
                            name: 'Podcasts',
                            actions: []
                        }
                    }
                },
            },

            current_tab_id: null,

            // paths: {
            //     custom,
            //     built_in,
            // }

        }
    },

    computed: {

        window() {
            return window.$(window);
        },

        tab_ids() {
            return Object.keys(this.tabs);
        },

        lp() {
            return this.learningPath;
        },

        current_tab() {
            return this.tabs[this.current_tab_id];
        },

        resources() {
            if (!this.lp) return [];

            const items = [];
            for (const i in this.lp.stages) {
                if (!this.lp.stages.hasOwnProperty(i)) continue;
                items.concat(this.lp.stages[i].resources);
            }
            return items;
        },

        activities() {
            if (!this.lp) return [];

            const items = [];
            for (const i in this.lp.stages) {
                if (!this.lp.stages.hasOwnProperty(i)) continue;
                items.concat(
                    this.lp.stages[i].activity_sections
                        .map((s) => s.activities)
                );
            }
            return items;
        },


        lp_stages() {
            return this.lp.fragments.stages;
        },

        lp_activity_section_groups() {
            const groups = [];
            for (const i in this.lp_stages) {
                const stage_id = this.lp_stages[i];
                const stage = this.lp.fragments[`stage_${stage_id}_config`];
                const section = this.lp.fragments[`stage_${stage_id}_activity_sections`]

                if (!section || !section.length) {
                    groups.push({
                        stage_id,
                        stage,
                        group: null,
                    });
                } else {
                    for (const j in section) {
                        groups.push({
                            stage_id,
                            stage,
                            group: this.lp.fragments[`stage_${stage_id}_activity_sections`][j],
                        });
                    }
                }
            }

            return groups;
        },

    },

    watch: {
        current_tab_id(stage) {
            const $stage_content = window.$(`#stage-content-${stage}`);
            if (!$stage_content.length) return;

            const $body = window.$('html, body');
            $body.animate({ scrollTop: $stage_content.offset().top - 80 }, 500);
        }
    },


    methods: {

        ...mapActions('repositories', { repo: 'getRepository', updateRepo: 'updateRepository' }),

        uniqueActionGrouped(actions, type) {
            /** Get unique groups of type field from  */
            const uniqueGroups = [
                ...new Map(
                    actions
                        .map(a => a.groups)
                        .reduce((prev, val) => prev.concat(val), [])
                        .filter(g => g.type === type)
                        .map(item => [item.id, item])
                ).values()
            ];

            return uniqueGroups;

            // console.log( groups );


            // actions = actions.map(action => action[ field ]);
            // if( field === 'group' ){
            //     actions.filter((val, idx, self) => self.indexOf(val) === idx)
            // }
        },

        icon(action) {
            if (action?.icon || action.icon !== '') return action.icon;
            switch (action.type) {
                case 'resource': return '/images/icons/toolbox/resource-default.svg';
                case 'activity': return '/images/icons/toolbox/activity-default.svg';
                default: return '/images/icons/toolbox/default.svg';
            }
        },

        filteredActions(actions, filters) {
            // console.log({actions, filters});
            return actions.filter(action => {
                if (!filters) return true;
                const keys = Object.keys(filters);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if (filters[key] === '') continue;
                    if (action.groups.filter(g => (g.type === key && g.id === filters[key])).length === 0) return false;
                }
                return true;
            }).map(action => {
                action.icon = this.icon(action);
                return action;
            });
        },

        scroll(id) {

            const el = this.$refs[`${this.current_tab_id}-section-${id}`];
            const $toolbox = window.$('.learning-path-toolbox .toolbox-content');
            const data = {
                el_top: window.$(el).offset()?.top,
                win_scroll: window.$(window).scrollTop(),
                tool_top: $toolbox.offset()?.top,
                tool_scroll: $toolbox.scrollTop(),
            };
            const scrollTop = (data.el_top - data.tool_top);
            $toolbox.animate({ scrollTop }, 500);
        },


        loadTools() {
            this.loadResources();
            this.loadActivities();
            this.loadPodcasts();
        },

        async loadResources() {

            this.busy.resources = true;

            for (const stage in this.tabs) {
                this.tabs[stage].sections.resources.actions = [];
            }

            const resources = await API.elements.bulk({ type: 'resource', tenant_id: this.$page.props.active_tenant.id, user_id: this.current_user_id });
            for (const stage in this.tabs) {
                this.tabs[stage].sections.resources.actions = resources.filter(r => r.groups.map(g => g.name).indexOf(stage) >= 0);
            }

            this.busy.resources = false;


        },

        async loadActivities() {

            this.busy.activities = true;

            for (const stage in this.tabs) {
                this.tabs[stage].sections.activities.actions = [];
            }

            const activities = await API.elements.bulk({ type: 'activity', tenant_id: this.$page.props.active_tenant.id, user_id: this.current_user_id });
            for (const stage in this.tabs) {
                this.tabs[stage].sections.activities.actions = activities.filter(a => (a.groups.filter(a => a.type === 'stage').map(a => a.name)).indexOf(stage) >= 0);
            }

            this.busy.activities = false;

        },

        async loadPodcasts() {
            this.busy.podcasts = true
            this.podcasts = await API.podcasts.bulk()
            let podcastArr = []
            const canvasElements = await API.elements.bulk()
            const podcastElementObj = canvasElements.filter(el => el.type === 'resource' && el.data.type === 'podcast')[0]
            console.log("PODCAST ELEMENT", podcastElementObj)
            for (const podcast in this.podcasts) {
                podcastArr.push({
                    ...podcastElementObj,
                    podcastId: this.podcasts[podcast].id,
                    data: {
                        url: null,
                        file: {
                            url: this.podcasts[podcast].image_file.url,
                            mime: this.podcasts[podcast].image_file.mime,
                            name: this.podcasts[podcast].name,
                            preview_url: this.podcasts[podcast].image_file.preview_url,
                            uploaded_by_id: this.podcasts[podcast].image_file.uploaded_by_id
                        },
                        type: "podcast",
                        options: {
                            width: "3"
                        },
                        preview_url: null
                    }
                })
            }
            for (const stage in this.tabs) {
                this.tabs[stage].sections.podcasts.actions = podcastArr
            }
            this.busy.podcasts = false
        },

        addToSection(modal) {

            const element = _.clone(modal.item.item);

            switch (element.type) {
                case 'resource':
                    element.color = this.utils.hslToHex(this.utils.random(0, 360), this.utils.random(0, 80), this.utils.random(40, 75));
            }

            this.emitter.emit('path.add-element', {
                element: {
                    id: this.utils.randomId({ prefix: 'el' }),
                    element,
                },
                stage_id: this.add_to_section.stage_id,
                group_id: this.add_to_section.group_id,
            });

            // Close modal by setting it null.
            modal.item.item = null;

        },

        async addToSection2() {

            const item = this.tabs.intro.sections.podcasts.actions.filter(podcast => podcast.podcastId === this.selectedPodcast.id)[0]

            const element = _.clone(item);

            element.color = this.utils.hslToHex(this.utils.random(0, 360), this.utils.random(0, 80), this.utils.random(40, 75));

            const randomId = this.utils.randomId({ prefix: 'el' })

            const fragments = {};
            fragments[`stage_${this.add_to_section.stage_id}_${this.add_to_section.group_id}_podcast_${randomId}`] = this.selectedPodcast ? {
                podcast: {id: this.selectedPodcast.id, short_name: this.selectedPodcast.slug},
            } : null;
            this.updateRepo({scope: this.learningPath.scope, fragments});

            this.emitter.emit('path.add-element', {
                element: {
                    id: randomId,
                    element,
                },
                stage_id: this.add_to_section.stage_id,
                group_id: this.add_to_section.group_id,
            });

            // Close modal by setting it null.
            this.selectedPodcast = null;
            this.$emit('reload-page')

        },


        openCanvasElementEditor(type, element = null) {

            this.elementEditorModal.type = {
                activities: 'activity',
                resources: 'resource',
                activity: 'activity',
                resource: 'resource',
            }[type];

            this.elementEditorModal.element = element;
            this.elementEditorModal.show = true;
        },

        closeCanvasElementEditor() {
            this.elementEditorModal.type = null;
            this.elementEditorModal.element = null;
            this.elementEditorModal.show = false;
        },

        onCanvasElementEditorSave(element) {
            console.log({ created: element });
            this.closeCanvasElementEditor();
            this.loadTools();
        },

        async removeTool(tool) {
            if (!confirm('Are you sure to remove this tool permanently?')) return;
            console.log(tool);
            await API.elements.destroy(tool.element.id);
            this.loadTools();
        },

        cloneTool(tool) {
            const element = _.clone(tool);

            element.color = this.utils.hslToHex(this.utils.random(0, 360), this.utils.random(0, 80), this.utils.random(40, 75));

            const randomId = this.utils.randomId({ prefix: 'el' })

            return {
                id: randomId,
                element,
                fromLearningPath: true,
                scope: this.learningPath.scope,
                podcast: this.podcasts.filter(podcast => podcast.id === element.podcastId)[0]
            };

        },

        preview(element) {
            this.selectedPodcast = this.podcasts.filter(podcast => podcast.id === element.podcastId)[0];
        },

        close() {
            this.selectedPodcast = null;
        },
    },


    beforeMount() {
        if (this.tab_ids.length > 0) {
            this.current_tab_id = this.tab_ids[0];
        }
    },

    mounted() {
        this.loadTools();
        // window.$(window).on('scroll', this.autoActivateTabOnScroll);
    },

    beforeUnmount() {
        // window.$(window).offset('scroll', this.autoActivateTabOnScroll);
    }

}
</script>
<style lang="scss">
.learning-path-toolbox.toolbox-pane {
    position: relative;

    .toolbox-content {
        // margin-top: 95px;
        border-top: $primary solid 1px;
    }

    // .nav-tabs{
    //     position: absolute;
    //     top: 58px;
    //     right: 0;
    //     left: 0;
    // }

    // .pre-tab-content{
    //     position: absolute;
    //     top: 100px;
    //     left: 0;
    //     right: 0;
    // }
    .pre-tab-content {
        margin: 10px 0;
    }
}

@media (min-width: 650px) and (max-width: 1199px) {
    .learning-path-toolbox.toolbox-pane {
        .toolbox-content {
            // margin-top: 113px;
            border-top: $primary solid 1px;
        }

        .nav-tabs {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }

        // .pre-tab-content{
        //     top: 123px;
        // }
    }
}
</style>
<style lang="scss" scoped>
.learning-path-toolbox {
    width: 382px;
}

@media (min-width: 650px) and (max-width: 1199px) {
    .learning-path-toolbox {
        width: 200px;
    }
}

.section-head {
    display: flex;
    align-items: center;
    padding: 0.4rem 1rem;
    background: darken(white, 15%);
    margin-left: -1rem;
    margin-right: -1rem;
}

.podcasts-head {
    height: 61.8px;
}

.tool {
    &:hover {
        .path-tool-actions {
            opacity: 1;
        }
    }
}

.path-tool-actions {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    opacity: 0;
    width: 100%;
    justify-content: flex-end;
    transition: opacity .3s;
    padding: .3rem;
}

.tool-remove {
    background: $danger;
    border-radius: 50%;
    width: 1.2rem;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: $font-weight-bold;
    text-decoration: none;
}

.custom {
    position: absolute;
    left: .3rem;
    top: .3rem;
    width: 8px;
    height: 8px;
    background: orange;
    border-radius: 50%;
    z-index: 2;
    box-shadow: rgba(black, 0.1) 0 1px 2px;
    border: white solid 1px;
}

//.btn{
//    display: flex;
//    align-items: center;
//    text-align: left;
//    padding: 0.675rem 0.75rem;
//    margin-bottom: 0.4rem;
//
//    img{
//        display: block;
//        width: 24px;
//        height: 24px;
//        flex: 0 0 24px;
//        object-fit: contain;
//        margin-right: 0.5rem;
//    }
//}

.tools {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    align-items: stretch;
    position: relative;

    .tool {
        flex: 0 0 33.33333333%;
        width: 33.333333333%;
        padding: 0.3rem;
        display: flex;
        align-items: stretch;
        position: relative;

        button {
            padding: 0;

            img {
                width: 100%;
            }

            span {
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
                width: 100%;
                padding: 0.3rem;
            }
        }
    }
}
</style>
